// hello

console.log("✿ hello you, I hope you're having a lovely day ✿")
